export default [
  {
    header: 'API Documentation',
    title: 'API Documentation',
    name: 'api-documentation',
    icon: 'CodeIcon',
    target: '_blank',
    href: '/api',
  },
]